
import { defineComponent, ref } from 'vue';
import { useRouter } from 'vue-router';
import {
  default as FishingTubesModel,
  FishingTubes,
} from '../../models/fishingTubes.model';
import FileUpload from '../../components/ui/FileUpload.vue';
import SubmitButton from '../../components/ui/SubmitButton.vue';
import dateTimeHelper from '../../helper/datetime.helper';
import Editor from '../../components/ui/Editor.vue';
import swal from '../../helper/swal.helper';

export default defineComponent({
  components: {
    FileUpload,
    SubmitButton,
    Editor,
  },
  setup() {
    const router = useRouter();
    let thumbnailFile = ref<any>(null);
    let customEditor = ref<any>(null);
    let isSubmitting = ref(false);
    let fishingTube = ref<FishingTubes>({
      name: '',
      show: true,
      video_id: '',
      desc: '',
      thumbnail: '',
      published_at: 0,
      updated_at: 0,
      created_at: 0,
      view_count: 0,
      order: 0,
      show_view_count: false,
    });
    let publishTime = ref<string>('');

    async function submitForm() {
      isSubmitting.value = true;

      let data = {
        created_at: new Date(),
        desc: await customEditor.value?.getContents(),
        video_id: fishingTube.value.video_id,
        published_at: publishTime.value
          ? dateTimeHelper.dateToTimestamp(publishTime.value)
          : 0,
        show: fishingTube.value.show,
        thumbnail: await thumbnailFile.value?.uploadImage(),
        name: fishingTube.value.name,
        view_count: fishingTube.value.view_count,
        order: fishingTube.value.order,
        show_view_count: fishingTube.value.show_view_count,
      };
      let addResult = await FishingTubesModel.create(data);
      if (addResult.status) {
        isSubmitting.value = false;
        router.push('/fishing-tubes');
      } else {
        swal.alert(addResult.message);
        isSubmitting.value = false;
      }
    }

    return {
      fishingTube,
      thumbnailFile,
      submitForm,
      isSubmitting,
      publishTime,
      customEditor,
    };
  },
});
